import { Controller } from "@hotwired/stimulus"
import { createElement } from "react"
import { createRoot } from "react-dom/client"

const MODES = {}

function resolveMode(name) {
  return MODES[name]
}

async function loadModes() {
  const [{ fullMode }, { inlineMode }] = await Promise.all([
    import(/* webpackMode: "eager" */ "../tiptap/modes/full-mode"),
    import(/* webpackMode: "eager" */ "../tiptap/modes/inline-mode"),
  ])
  MODES.full = fullMode
  MODES.inline = inlineMode
}

export default class extends Controller {
  static targets = ["editor"]
  static values = {
    content: String,
    mode: { type: String, default: "full" },
    recordType: { type: String, default: "" },
    recordId: { type: String, default: "" },
  }

  connect() {
    this.mountReactEditor()
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }

  async mountReactEditor() {
    try {
      const [{ TiptapEditorShell }] = await Promise.all([
        import(/* webpackMode: "eager" */ "../tiptap/shell/tiptap-editor-shell"),
        loadModes(),
      ])

      const mode = resolveMode(this.modeValue)

      this.root = createRoot(this.editorTarget)
      this.root.render(
        createElement(TiptapEditorShell, {
          content: this.contentValue || "",
          mode,
          recordType: this.recordTypeValue,
          recordId: this.recordIdValue,
          onChange: (html) => this.handleChange(html),
        })
      )
    } catch (error) {
      console.error("[tiptap] Failed to mount editor:", error)
    }
  }

  handleChange(html) {
    this.dispatch("change", { detail: { content: html } })
  }
}
